/**
 * Recusa do pay que aponta UM campo do formulário (curseduca-pay#632):
 * `400 { code: 'invalid_field', field: 'address.postalcode', message: 'Confira o campo CEP: … Ref. PAY-…' }`.
 * A tela marca o campo com a mensagem, para o comprador saber o que corrigir (pedido do Bryan, 29/10).
 */

/** Campos do formulário do checkout que o pay pode apontar. Fora desta lista, só o toast. */
const FORM_FIELDS = [
	'name',
	'email',
	'phone',
	'cpfCnpj',
	'address.postalcode',
	'address.address',
	'address.number',
	'address.complement',
	'address.province',
	'address.city',
	'address.state'
] as const;

export type FormField = (typeof FORM_FIELDS)[number];

export function apiFieldErrorOf(
	error: unknown
): { field: FormField; message: string } | null {
	const data = (
		error as {
			response?: {
				data?: { code?: unknown; field?: unknown; message?: unknown };
			};
		}
	)?.response?.data;
	if (data?.code !== 'invalid_field') return null;
	const field = FORM_FIELDS.find((f) => f === data.field);
	if (!field || typeof data.message !== 'string') return null;
	// A Ref. fica no toast; embaixo do campo, só o que corrigir.
	const message = data.message.replace(/\s*Ref\.\s*\S+\s*$/, '').trim();
	return message ? { field, message } : null;
}

/**
 * O campo está na tela? `setError` num campo que não está montado (endereço oculto, telefone fora
 * do formulário desta oferta) fica preso em `formState.errors`: o `handleSubmit` não revalida esse
 * nome, e o próximo "Finalizar compra" trava em silêncio. Lê `control._fields` do react-hook-form
 * (`_f.mount` é o que o RHF liga no register/Controller montado e desliga ao desmontar).
 */
export function isFieldMounted(fields: unknown, name: string): boolean {
	const node = name
		.split('.')
		.reduce<unknown>(
			(acc, key) =>
				acc && typeof acc === 'object'
					? (acc as Record<string, unknown>)[key]
					: undefined,
			fields
		) as { _f?: { mount?: unknown } } | undefined;
	return node?._f?.mount === true;
}

/** CEP brasileiro: 8 dígitos (o envio tira o que não é dígito). */
export const isValidCep = (value: unknown) =>
	String(value ?? '').replace(/\D/g, '').length === 8;
